var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec2Icon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec2Icon1",
    transform: "translate(-480 -878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4860",
    "data-name": "\\uC0AC\\uAC01\\uD615 4860",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(480 878)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "free-icon-envelope-1358973",
    transform: "translate(491 892.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33740",
    "data-name": "\\uD328\\uC2A4 33740",
    d: "M0,.168H28v20H0Zm0,0",
    transform: "translate(0 0)",
    fill: "#afc3e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33741",
    "data-name": "\\uD328\\uC2A4 33741",
    d: "M30.673,80.94a7.955,7.955,0,0,1-5.294-2.013l-7.649-6.8.845-.951,7.649,6.8a6.866,6.866,0,0,0,8.9,0l7.649-6.8.845.951-7.649,6.8A7.955,7.955,0,0,1,30.673,80.94Zm0,0",
    transform: "translate(-16.673 -66.918)",
    fill: "#95afe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33742",
    "data-name": "\\uD328\\uC2A4 33742",
    d: "M1.9,136.658l7.649-6.8a6.7,6.7,0,0,1,8.9,0l7.65,6.8a5.668,5.668,0,0,1,1.9,4.236H0a5.668,5.668,0,0,1,1.9-4.236Zm0,0",
    transform: "translate(-0.001 -120.727)",
    fill: "#cfdbf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33743",
    "data-name": "\\uD328\\uC2A4 33743",
    d: "M14,12.895A6.694,6.694,0,0,0,18.448,11.2L26.1,4.4A5.669,5.669,0,0,0,28,.168H0A5.668,5.668,0,0,0,1.9,4.4l7.649,6.8A6.7,6.7,0,0,0,14,12.895Zm0,0",
    transform: "translate(0 0)",
    fill: "#e6ecf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33744",
    "data-name": "\\uD328\\uC2A4 33744",
    d: "M127.7,167.208a7.955,7.955,0,0,1-5.294-2.013l-1.493-1.327.845-.951,1.493,1.327a6.866,6.866,0,0,0,8.9,0l1.493-1.327.845.951L133,165.2A7.955,7.955,0,0,1,127.7,167.208Zm0,0",
    transform: "translate(-113.704 -153.26)",
    fill: "#afc3e9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec2Icon1);
export default __webpack_public_path__ + "static/media/sec2Icon1.a3209723b3610dfc6348b0a10d76ac2d.svg";
export { ForwardRef as ReactComponent };